export class DeheadingFilterReq{
    foodTypeId: number
    valueAdd1: number
    valueAdd2: number
    basedOn : number
    constructor(
        foodTypeId: number,
        valueAdd1: number,
        valueAdd2: number,
        basedOn : number
    ){
        this.foodTypeId=foodTypeId
        this.valueAdd1=valueAdd1
        this.valueAdd2=valueAdd2
        this.basedOn = basedOn
    }
}